export default "__VITE_ASSET__a3ede1f1__"